// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".plan[data-v-20c7145c]{border:1px solid #e0e0e0;padding:32px 0}.events-count[data-v-20c7145c]{height:3rem}.description-container[data-v-20c7145c]{height:6rem;max-width:20rem}", ""]);
// Exports
module.exports = exports;
